// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { FormattedMessage } from 'react-intl';
import { Desktop, Tablet } from '../../utils/responsive';
import Slider from 'react-slick/lib';
import Arrow from '../Arrow/Arrow';

import style from './CarouselImages.scss';
import icons from '../../assets/styles/icons.scss';

import type { Element } from 'react';

type Props = {
  +items: string[];
  +title: string;
};

type State = {
  lightningRightArrow: boolean;
  lightningLeftArrow: boolean;
};

export default class CarouselImages extends Component<Props, State> {
  state = {
    lightningRightArrow: false,
    lightningLeftArrow: true,
  };

  handleArrowStyle(current: number, lastIndex: number) {
    const lightningLeftArrow = current === 0;
    const lightningRightArrow = current === lastIndex;
    this.setState({ lightningLeftArrow, lightningRightArrow });
  }

  buildBoxes(): Array<Element<'img'>> {
    const { items } = this.props;
    return items && items.map((image: string, n: number) =>
      (<img key={n}
            src={image}
            alt="Qempo"/>));
  }

  render() {
    const { title } = this.props;
    const { lightningRightArrow, lightningLeftArrow } = this.state;
    const images = this.buildBoxes();

    const options = {
      infinite: false,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      draggable: true,
      nextArrow: <Arrow icon={icons.iconChevronRightMedium}
                        positionClass={style.arrowRight}
                        visible={lightningRightArrow}/>,
      prevArrow: <Arrow icon={icons.iconChevronLeftMedium}
                        positionClass={style.arrowLeft}
                        visible={lightningLeftArrow}/>,
    };
    const tabletSlideToShow = 5;
    const tableSettings = {
      ...options,
      slidesToShow: tabletSlideToShow,
      afterChange: (current) => this.handleArrowStyle(current, images.length - tabletSlideToShow),
    };
    const desktopSlideToShow = 7;
    const desktopSettings = {
      ...options,
      slidesToShow: desktopSlideToShow,
      afterChange: (current) => this.handleArrowStyle(current, images.length - desktopSlideToShow),
    };

    return (
      <section className={style.carouselImages}>
        <FormattedMessage id={title}>{
          text => <h2>{text}</h2>
        }</FormattedMessage>
        <section className={classNames(style.images, style.mobile)}>
          <Fragment>
            {images}
          </Fragment>
        </section>
        <section className={classNames(style.carousel, style.desktop)}>
          <Tablet>
            <Slider {...tableSettings}>
              {images && images.map((image: Element<'img'>, n: number) => (
                <article key={n} className={style.imageWrap}>{image}</article>))}
            </Slider>
          </Tablet>
          <Desktop>
            <Slider {...desktopSettings}>
              {images && images.map((image: Element<'img'>, n: number) => (
                <article key={n} className={style.imageWrap}>{image}</article>))}
            </Slider>
          </Desktop>
        </section>
      </section>);
  }
}

CarouselImages.propTypes = {
  items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/CarouselImages/CarouselImages.jsx